import { Middleware } from 'redux';
import { INIT_UPDATER } from '../actions/actionTypes';
import { receiveUpdaterMsg } from '../actions/updater';
import { TUpdater } from '../reducers/updater';

const host = process.env.REACT_APP_UPDATER;

const websocketMiddleware: Middleware = (store) => {
  let ws: WebSocket | null = null;

  const openConnection = () => {
    ws = null;
    ws = new WebSocket(`ws://${host}/updater`);

    ws.onopen = () => {
      console.log('updater connected');
    };

    ws.onmessage = (evt: MessageEvent) => {
      const { data } = evt;
      const updaterData: TUpdater = { data: JSON.parse(data) };

      store.dispatch(receiveUpdaterMsg(updaterData));
    };

    ws.onclose = (evt: CloseEvent) => {
      console.log(
        `updater has been disconnected, code ${evt.code}; trying to reconnect`,
      );
      setTimeout(() => openConnection(), 5000);
    };

    ws.onerror = (err: Event) => {
      console.log(err);
      ws?.close();
    };
  };

  return (next) => (action) => {
    const { type } = action;

    if (type === INIT_UPDATER) {
      openConnection();
    }

    next(action);
  };
};

export default websocketMiddleware;
